import React, { useRef } from "react";
import { Switch } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";

const TransitionRoute = ({ location, children, ...transitionProps }) => {
    const nodeRef = useRef(null);

    return (
        <CSSTransition
            {...transitionProps}
            nodeRef={nodeRef}
            classNames="fadeTranslate"
            timeout={500}
            mountOnEnter
            unmountOnExit
        >
            <div ref={nodeRef}>
                <Switch location={location}>{children}</Switch>
            </div>
        </CSSTransition>
    );
};

const TransitionSwitch = ({ name, location, children }) => (
    <div className="transition-group-wrap">
        <TransitionGroup>
            <TransitionRoute key={name} location={location}>
                {children}
            </TransitionRoute>
        </TransitionGroup>
    </div>
);

export default TransitionSwitch;
